import gql from 'graphql-tag';

export default gql`
  mutation deleteIntegration($id: UUID!) {
    deleteIntegration(_id: $id)
  }
`;
